import * as schemaUtils from '@flows/configs/shared/schemaUtils'
import type { StepConfigParams } from '@flows/configs/types'
import type { AnyStepConfiguration } from '@flows/core/types/stepTypes'
import { BaseSchema_PetHealthV1GetsafeDe } from '@flows/insurance/schemas'

const pet_previous_insurance = (params: StepConfigParams) =>
  ({
    schema: schemaUtils.generateZodObjectFromPaths({
      [params.helperFunctions.getParamPath('previous_insurance_in_last_5y')]:
        BaseSchema_PetHealthV1GetsafeDe.shape.previous_insurance_in_last_5y.unwrap(),
    }),
    stepContent: [
      {
        type: 'title',
        text: {
          type: 'translatableText',
          translationKey: 'sharedFlows_petHealth:steps.pet_previous_insurance.title',
        },
      },
      {
        type: 'yesNo',
        shouldTrackValues: true,
        name: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      },
    ],
    subFlow: params.subFlow,
    nextStepConfig: {
      valuePath: params.helperFunctions.getParamPath('previous_insurance_in_last_5y'),
      valueToStepName: {
        true: 'pet_previous_insurer',
        false: 'pet_treatment',
      },
    },
  }) as const satisfies AnyStepConfiguration

export default pet_previous_insurance
